import { render, staticRenderFns } from "./follow-record-insert.vue?vue&type=template&id=fae86354&scoped=true"
import script from "./follow-record-insert.vue?vue&type=script&lang=ts"
export * from "./follow-record-insert.vue?vue&type=script&lang=ts"
import style0 from "./follow-record-insert.vue?vue&type=style&index=0&id=fae86354&prod&lang=less&scoped=true"
import style1 from "./follow-record-insert.vue?vue&type=style&index=1&id=fae86354&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae86354",
  null
  
)

export default component.exports